import React from 'react';
import { graphql } from 'gatsby';
import Layout from "./layout"
import SEO from "./seo"
import { createGlobalStyle } from "styled-components"
import * as style from "./css/blogPost.module.css"

const GlobalStyle = createGlobalStyle`
body { background-color: #f4f4f4 !important; font-family:sans-serif; color: black;}
`

export const pageQuery = graphql`
  query BlogByID($id: String) {
    wpPost(id: {eq: $id}) {
      date(locale: "jp", formatString: "yyyy年M月D日")
      id
      slug
      title
      content
      excerpt
      featuredImage {
        node {
          localFile {
            url
            childImageSharp {
              fluid(maxWidth: 1024)  {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
      tags {
        nodes {
          slug
          name
        }
      }
      categories {
        nodes {
          slug
          name
        }
      }
    }
  }
`;

const Blog = (props) => {
  const { data } = props;
  const { wpPost: post } = data;

  const siteTitle = post.title
  const featuredImage = (post.featuredImage) ? post.featuredImage.node.localFile.childImageSharp.fluid.src : ""
  const description = post.excerpt
  const cate = post.categories.nodes[0].slug

  return (
    <Layout>

      <SEO title={siteTitle}
          ogpImage={featuredImage} 
          description={description}/>

      <React.Fragment>
        <GlobalStyle />
      </React.Fragment>

      <div id="blogPost" className={`${style.wrap} cate-${cate} slug-${post.slug}`} data-cate={`${cate}`} >
        <h1 className={`${style.title} blog-title`}>{post.title}</h1>
        <p className={`${style.meta} blog-meta`}>
          更新日:{post.date}
        </p>
        <div className={`${style.entry} entry`}
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
    </div>
    </Layout>
  );
};

export default Blog;